webpackJsonp([1],{

/***/ 1293:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 47,
	"./af.js": 47,
	"./ar": 54,
	"./ar-dz": 48,
	"./ar-dz.js": 48,
	"./ar-kw": 49,
	"./ar-kw.js": 49,
	"./ar-ly": 50,
	"./ar-ly.js": 50,
	"./ar-ma": 51,
	"./ar-ma.js": 51,
	"./ar-sa": 52,
	"./ar-sa.js": 52,
	"./ar-tn": 53,
	"./ar-tn.js": 53,
	"./ar.js": 54,
	"./az": 55,
	"./az.js": 55,
	"./be": 56,
	"./be.js": 56,
	"./bg": 57,
	"./bg.js": 57,
	"./bm": 58,
	"./bm.js": 58,
	"./bn": 59,
	"./bn.js": 59,
	"./bo": 60,
	"./bo.js": 60,
	"./br": 61,
	"./br.js": 61,
	"./bs": 62,
	"./bs.js": 62,
	"./ca": 63,
	"./ca.js": 63,
	"./cs": 64,
	"./cs.js": 64,
	"./cv": 65,
	"./cv.js": 65,
	"./cy": 66,
	"./cy.js": 66,
	"./da": 67,
	"./da.js": 67,
	"./de": 70,
	"./de-at": 68,
	"./de-at.js": 68,
	"./de-ch": 69,
	"./de-ch.js": 69,
	"./de.js": 70,
	"./dv": 71,
	"./dv.js": 71,
	"./el": 72,
	"./el.js": 72,
	"./en-au": 73,
	"./en-au.js": 73,
	"./en-ca": 74,
	"./en-ca.js": 74,
	"./en-gb": 75,
	"./en-gb.js": 75,
	"./en-ie": 76,
	"./en-ie.js": 76,
	"./en-nz": 77,
	"./en-nz.js": 77,
	"./eo": 78,
	"./eo.js": 78,
	"./es": 81,
	"./es-do": 79,
	"./es-do.js": 79,
	"./es-us": 80,
	"./es-us.js": 80,
	"./es.js": 81,
	"./et": 82,
	"./et.js": 82,
	"./eu": 83,
	"./eu.js": 83,
	"./fa": 84,
	"./fa.js": 84,
	"./fi": 85,
	"./fi.js": 85,
	"./fo": 86,
	"./fo.js": 86,
	"./fr": 89,
	"./fr-ca": 87,
	"./fr-ca.js": 87,
	"./fr-ch": 88,
	"./fr-ch.js": 88,
	"./fr.js": 89,
	"./fy": 90,
	"./fy.js": 90,
	"./gd": 91,
	"./gd.js": 91,
	"./gl": 92,
	"./gl.js": 92,
	"./gom-latn": 93,
	"./gom-latn.js": 93,
	"./gu": 94,
	"./gu.js": 94,
	"./he": 95,
	"./he.js": 95,
	"./hi": 96,
	"./hi.js": 96,
	"./hr": 97,
	"./hr.js": 97,
	"./hu": 98,
	"./hu.js": 98,
	"./hy-am": 99,
	"./hy-am.js": 99,
	"./id": 100,
	"./id.js": 100,
	"./is": 101,
	"./is.js": 101,
	"./it": 102,
	"./it.js": 102,
	"./ja": 103,
	"./ja.js": 103,
	"./jv": 104,
	"./jv.js": 104,
	"./ka": 105,
	"./ka.js": 105,
	"./kk": 106,
	"./kk.js": 106,
	"./km": 107,
	"./km.js": 107,
	"./kn": 108,
	"./kn.js": 108,
	"./ko": 109,
	"./ko.js": 109,
	"./ky": 110,
	"./ky.js": 110,
	"./lb": 111,
	"./lb.js": 111,
	"./lo": 112,
	"./lo.js": 112,
	"./lt": 113,
	"./lt.js": 113,
	"./lv": 114,
	"./lv.js": 114,
	"./me": 115,
	"./me.js": 115,
	"./mi": 116,
	"./mi.js": 116,
	"./mk": 117,
	"./mk.js": 117,
	"./ml": 118,
	"./ml.js": 118,
	"./mr": 119,
	"./mr.js": 119,
	"./ms": 121,
	"./ms-my": 120,
	"./ms-my.js": 120,
	"./ms.js": 121,
	"./mt": 122,
	"./mt.js": 122,
	"./my": 123,
	"./my.js": 123,
	"./nb": 124,
	"./nb.js": 124,
	"./ne": 125,
	"./ne.js": 125,
	"./nl": 127,
	"./nl-be": 126,
	"./nl-be.js": 126,
	"./nl.js": 127,
	"./nn": 128,
	"./nn.js": 128,
	"./pa-in": 129,
	"./pa-in.js": 129,
	"./pl": 130,
	"./pl.js": 130,
	"./pt": 132,
	"./pt-br": 131,
	"./pt-br.js": 131,
	"./pt.js": 132,
	"./ro": 133,
	"./ro.js": 133,
	"./ru": 134,
	"./ru.js": 134,
	"./sd": 135,
	"./sd.js": 135,
	"./se": 136,
	"./se.js": 136,
	"./si": 137,
	"./si.js": 137,
	"./sk": 138,
	"./sk.js": 138,
	"./sl": 139,
	"./sl.js": 139,
	"./sq": 140,
	"./sq.js": 140,
	"./sr": 142,
	"./sr-cyrl": 141,
	"./sr-cyrl.js": 141,
	"./sr.js": 142,
	"./ss": 143,
	"./ss.js": 143,
	"./sv": 144,
	"./sv.js": 144,
	"./sw": 145,
	"./sw.js": 145,
	"./ta": 146,
	"./ta.js": 146,
	"./te": 147,
	"./te.js": 147,
	"./tet": 148,
	"./tet.js": 148,
	"./th": 149,
	"./th.js": 149,
	"./tl-ph": 150,
	"./tl-ph.js": 150,
	"./tlh": 151,
	"./tlh.js": 151,
	"./tr": 152,
	"./tr.js": 152,
	"./tzl": 153,
	"./tzl.js": 153,
	"./tzm": 155,
	"./tzm-latn": 154,
	"./tzm-latn.js": 154,
	"./tzm.js": 155,
	"./uk": 156,
	"./uk.js": 156,
	"./ur": 157,
	"./ur.js": 157,
	"./uz": 159,
	"./uz-latn": 158,
	"./uz-latn.js": 158,
	"./uz.js": 159,
	"./vi": 160,
	"./vi.js": 160,
	"./x-pseudo": 161,
	"./x-pseudo.js": 161,
	"./yo": 162,
	"./yo.js": 162,
	"./zh-cn": 163,
	"./zh-cn.js": 163,
	"./zh-hk": 164,
	"./zh-hk.js": 164,
	"./zh-tw": 165,
	"./zh-tw.js": 165
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1293;

/***/ }),

/***/ 1322:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(321)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(1341),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1323:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(319)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(1336),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1324:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(323)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(1343),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1325:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(1345),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1326:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(324)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(1344),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1327:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(322)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(1342),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1328:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(320)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(1337),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1329:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(1335),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1330:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(318)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(1334),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1331:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(1340),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1332:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(1339),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1333:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(1338),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1334:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.msal.isAuthenticated) ? _c('section', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "table-wrapper-scroll-y"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.listOfBackupPackInstalled), function(packInstalled) {
    return _c('tr', {
      key: packInstalled.id,
      class: [_vm.backupAlarmLevel(packInstalled) === 'ERROR' ? 'text-danger' :
        _vm.backupAlarmLevel(packInstalled) === 'WARNING' ? 'text-warning' :
        _vm.backupAlarmLevel(packInstalled) === 'SUCCESS' ? 'text-success' :
        ''
      ]
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(packInstalled.container.Name) + "\n                      "), _c('i', [_vm._v("\n                      ["), (packInstalled.pack.Name === 'Sauvegarde locale') ? _c('span', [_vm._v("local")]) : (packInstalled.pack.Name === 'Sauvegarde sur serveur distant') ? _c('span', [_vm._v("distant")]) : (packInstalled.pack.Name === 'BackupHelper') ? _c('span', [_vm._v("BHelper")]) : _c('span', [_vm._v("autre")]), _vm._v("]\n                      ")])]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(_vm._f("moment")(packInstalled.LastRunDateTime, "YYYY/MM/DD")) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(packInstalled.LastRunResult) + "\n                    ")])])
  }))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "table-wrapper-scroll-y"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.listOfservicemonitoring), function(serviceMonitoring) {
    return _c('tr', {
      key: serviceMonitoring.id,
      class: [_vm.servicemonitoringAlarmLevel(serviceMonitoring) === 'ERROR' ? 'text-danger' :
        _vm.servicemonitoringAlarmLevel(serviceMonitoring) === 'WARNING' ? 'text-warning' :
        _vm.servicemonitoringAlarmLevel(serviceMonitoring) === 'SUCCESS' ? 'text-success' :
        ''
      ]
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(serviceMonitoring.ServiceName))]), _vm._v(" "), _c('td', [(serviceMonitoring.TimeSinceLastHB - new Date().getTimezoneOffset() == 0) ? _c('div', [_vm._v("À l'instant")]) : _c('div', [_vm._v(_vm._s(serviceMonitoring.TimeSinceLastHB - new Date().getTimezoneOffset()) + " minutes")])])])
  }))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "clearfix visible-sm-block"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("État des Backups")])]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "backupPie"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Liste des postes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Poste")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Dern. sauvegarde")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Statut sauvegarde")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("État des Services")])]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "servicemonitoringPie"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Liste des services")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Service")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Dernier signe de vie")])])])
}]}

/***/ }),

/***/ 1335:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": _vm.user.avatar,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.user.displayName))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header",
    staticStyle: {
      "height": "auto",
      "min-height": "85px",
      "padding-bottom": "15px"
    }
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.user.displayName))]), _vm._v(" "), _vm._l((_vm.user.roles), function(role) {
    return _c('small', {
      key: role
    }, [_vm._v(_vm._s(role))])
  })], 2)]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "user-footer"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat btn-block",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" "), _c('span', [_vm._v("Logout")])])])
}]}

/***/ }),

/***/ 1336:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.msal.isAuthenticated) ? _c('div', {
    attrs: {
      "id": "authPage"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('h1', [_vm._v("Authentification")]), _vm._v(" "), _c('h4', [_vm._v("Veuillez vous connecter.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.$msal.signIn()
      }
    }
  }, [_vm._v("Connexion")])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1337:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("OUTILS")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Dashboard")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-sign-out",
    on: {
      "click": function($event) {
        _vm.$msal.signOut()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page",
    on: {
      "click": function($event) {
        _vm.$msal.signOut()
      }
    }
  }, [_vm._v("Déconnexion")])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1338:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['info-box', _vm.colorClass]
  }, [_c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    class: _vm.iconClasses
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.number))]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    style: ({
      width: _vm.progress + '%'
    })
  })]), _vm._v(" "), _c('span', {
    staticClass: "progress-description"
  }, [_vm._v(_vm._s(_vm.description))])])])
},staticRenderFns: []}

/***/ }),

/***/ 1339:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box"
  }, [_c('span', {
    class: ['info-box-icon', _vm.colorClass]
  }, [_c('i', {
    class: _vm.iconClasses
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.number))])])])
},staticRenderFns: []}

/***/ }),

/***/ 1340:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['alert', 'alert-' + _vm.type, {
      'alert-dismissible': _vm.dismissible
    }]
  }, [(_vm.dismissible) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]) : _vm._e(), _vm._v(" "), _c('h4', [_c('i', {
    class: ['icon', _vm.iconClasses]
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('span', [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1341:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notFound"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('h1', [_vm._v("You are lost.")]), _vm._v(" "), _c('h4', [_vm._v("This page doesn't exist.")]), _vm._v(" "), _c('router-link', {
    staticClass: "vertical-5p lead",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Take me home.")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1342:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('sidebar-menu')], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1343:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('dash-header', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.name.toUpperCase()) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.name.toUpperCase()))])])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('dash-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Accueil")])])
}]}

/***/ }),

/***/ 1344:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive center-block logo",
    attrs: {
      "src": "https://medias.intelisoft.ca/intelisoft_dashboard.png",
      "alt": "Logo"
    }
  })])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])])])
}]}

/***/ }),

/***/ 1345:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + "\n  "), _c('a', {
    attrs: {
      "href": "https://gaspesie.net",
      "target": "_blank"
    }
  }, [_vm._v("InteliSoft Informatique inc.")])]), _vm._v(" Tous droits réservés.\n")])
},staticRenderFns: []}

/***/ }),

/***/ 1346:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1370:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1371:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = domain;
/* harmony export (immutable) */ __webpack_exports__["a"] = count;
/* harmony export (immutable) */ __webpack_exports__["c"] = prettyDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = pluralize;
var urlParser = document.createElement('a');

function domain(url) {
  urlParser.href = url;
  return urlParser.hostname;
}

function count(arr) {
  return arr.length;
}

function prettyDate(date) {
  var a = new Date(date);
  return a.toDateString();
}

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }

  return time + label + 's';
}

/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_404_vue__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AuthPage_vue__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AuthPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AuthPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_Dashboard_vue__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_views_Dashboard_vue__);






var routes = [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default.a,
  children: [{
    path: 'dashboard',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_3__components_views_Dashboard_vue___default.a,
    name: 'Dashboard',
    meta: { description: 'État des systèmes' }
  }]
}, {
  path: '/AuthPage',
  component: __WEBPACK_IMPORTED_MODULE_2__components_AuthPage_vue___default.a
}, {
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_1__components_404_vue___default.a
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getters__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services__ = __webpack_require__(38);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_3__state__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_6__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* default */],
  plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__["a" /* default */])({
    paths: ['adminStatus', 'userId', 'userName']
  })]
});

__WEBPACK_IMPORTED_MODULE_7__services__["a" /* packinstalledService */].on('refreshData', function (packinstalled) {
  store.commit('FETCH_PACKINSTALLEDSAUVEGARDE', packinstalled.data);
});

__WEBPACK_IMPORTED_MODULE_7__services__["b" /* servicemonitoringService */].on('refreshData', function (servicemonitoring) {
  store.commit('FETCH_SERVICEMONITORING', servicemonitoring.data);
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(1346),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false
});

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_moment__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__filters__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_App_vue__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_msal__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_msal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_msal__);


















__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('count', __WEBPACK_IMPORTED_MODULE_7__filters__["a" /* count */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('domain', __WEBPACK_IMPORTED_MODULE_7__filters__["b" /* domain */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('prettyDate', __WEBPACK_IMPORTED_MODULE_7__filters__["c" /* prettyDate */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter('pluralize', __WEBPACK_IMPORTED_MODULE_7__filters__["d" /* pluralize */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_moment___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_4__routes__["a" /* default */],

  linkExactActiveClass: 'active',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */], router);

var redirectUri, postLogoutRedirectUri;
if (location.href.toLowerCase().indexOf('://localhost') > 0) {
  redirectUri = 'http://localhost:8080';
  postLogoutRedirectUri = 'http://localhost:8080/#/AuthPage';
} else {
  redirectUri = 'https://dashboard.intelisoft.ca';
  postLogoutRedirectUri = 'https://dashboard.intelisoft.ca/#/AuthPage';
}

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_msal___default.a, {
  auth: {
    clientId: '335df107-cbf6-451e-8a11-89617605bb2d',
    tenantId: '8e18cd54-284d-4c48-853f-b8eb22b82da7',
    redirectUri: redirectUri,
    postLogoutRedirectUri: postLogoutRedirectUri,
    autoRefreshToken: true
  },
  cache: {
    cacheLocation: 'sessionStorage'
  }
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#root',
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_8__components_App_vue___default.a);
  }
});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(38);


var fetchpackinstalledSauvegarde = function fetchpackinstalledSauvegarde(_ref) {
  var commit = _ref.commit;

  __WEBPACK_IMPORTED_MODULE_0__services__["a" /* packinstalledService */].find({
    query: {
      $sort: {
        id: 1
      }
    }
  }).then(function (packinstalled) {
    commit('FETCH_PACKINSTALLEDSAUVEGARDE', packinstalled.data);
  });
};

var fetchservicemonitoring = function fetchservicemonitoring(_ref2) {
  var commit = _ref2.commit;

  __WEBPACK_IMPORTED_MODULE_0__services__["b" /* servicemonitoringService */].find({
    query: {
      $sort: {
        id: 1
      }
    }
  }).then(function (servicemonitoring) {
    commit('FETCH_SERVICEMONITORING', servicemonitoring.data);
  });
};

var setAdminStatus = function setAdminStatus(_ref3, status) {
  var commit = _ref3.commit;

  commit('SET_ADMINSTATUS', status);
};

var setUserId = function setUserId(_ref4, userId) {
  var commit = _ref4.commit;

  commit('SET_USERID', userId);
};

var setUserName = function setUserName(_ref5, userName) {
  var commit = _ref5.commit;

  commit('SET_USERNAME', userName);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchpackinstalledSauvegarde: fetchpackinstalledSauvegarde,
  fetchservicemonitoring: fetchservicemonitoring,
  setAdminStatus: setAdminStatus,
  setUserId: setUserId,
  setUserName: setUserName
});

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAdmin", function() { return isAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userId", function() { return userId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userName", function() { return userName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allpackinstalledCount", function() { return allpackinstalledCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "successpackinstalledCount", function() { return successpackinstalledCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "warningpackinstalledCount", function() { return warningpackinstalledCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "errorpackinstalledCount", function() { return errorpackinstalledCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backupAlarmLevel", function() { return backupAlarmLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listOfBackupPackInstalled", function() { return listOfBackupPackInstalled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allservicemonitoringCount", function() { return allservicemonitoringCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "successservicemonitoringCount", function() { return successservicemonitoringCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "warningservicemonitoringCount", function() { return warningservicemonitoringCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "errorservicemonitoringCount", function() { return errorservicemonitoringCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "servicemonitoringAlarmLevel", function() { return servicemonitoringAlarmLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listOfservicemonitoring", function() { return listOfservicemonitoring; });
var isAdmin = function isAdmin(state) {
  return state.adminStatus;
};

var userId = function userId(state) {
  return state.userId;
};

var userName = function userName(state) {
  return state.userName;
};

var allpackinstalledCount = function allpackinstalledCount(state) {
  return state.packinstalled.length;
};

var successpackinstalledCount = function successpackinstalledCount(state) {
  return state.packinstalled.filter(function (p) {
    return p.LastRunResult.toLowerCase() === 'success' && p.NbDayLastRun <= 4;
  }).length;
};

var warningpackinstalledCount = function warningpackinstalledCount(state) {
  return state.packinstalled.filter(function (p) {
    return p.LastRunResult.toLowerCase() === 'success' && p.NbDayLastRun > 4 && p.NbDayLastRun <= 7;
  }).length;
};

var errorpackinstalledCount = function errorpackinstalledCount(state) {
  return state.packinstalled.filter(function (p) {
    return p.LastRunResult.toLowerCase() === 'error' || p.NbDayLastRun > 7;
  }).length;
};

var backupAlarmLevel = function backupAlarmLevel(state) {
  return function (p) {
    if (p.LastRunResult.toLowerCase() === 'success' && p.NbDayLastRun <= 4) {
      return 'SUCCESS';
    } else if (p.LastRunResult.toLowerCase() === 'success' && p.NbDayLastRun > 4 && p.NbDayLastRun <= 7) {
      return 'WARNING';
    } else if (p.LastRunResult.toLowerCase() === 'error' || p.NbDayLastRun > 7) {
      return 'ERROR';
    } else {
      return 'UNKNOWN';
    }
  };
};

var listOfBackupPackInstalled = function listOfBackupPackInstalled(state) {
  return state.packinstalled.sort(function (a, b) {
    return a.NbDayLastRun < b.NbDayLastRun ? 1 : a.NbDayLastRun > b.NbDayLastRun ? -1 : 0;
  }).sort(function (a, b) {
    return a.LastRunResult.toLowerCase() !== 'error' && b.LastRunResult.toLowerCase() === 'error' ? 1 : a.LastRunResult.toLowerCase() === 'error' && b.LastRunResult.toLowerCase() !== 'error' ? -1 : 0;
  });
};

var allservicemonitoringCount = function allservicemonitoringCount(state) {
  return state.servicemonitoring.length;
};

var successservicemonitoringCount = function successservicemonitoringCount(state) {
  var tzOffset = new Date().getTimezoneOffset();
  return state.servicemonitoring.filter(function (p) {
    return p.TimeSinceLastHB - tzOffset <= p.WarningThreshold;
  }).length;
};

var warningservicemonitoringCount = function warningservicemonitoringCount(state) {
  var tzOffset = new Date().getTimezoneOffset();
  return state.servicemonitoring.filter(function (p) {
    return p.TimeSinceLastHB - tzOffset > p.WarningThreshold && p.TimeSinceLastHB - tzOffset <= p.ErrorThreshold;
  }).length;
};

var errorservicemonitoringCount = function errorservicemonitoringCount(state) {
  var tzOffset = new Date().getTimezoneOffset();
  return state.servicemonitoring.filter(function (p) {
    return p.TimeSinceLastHB - tzOffset > p.ErrorThreshold;
  }).length;
};

var servicemonitoringAlarmLevel = function servicemonitoringAlarmLevel(state) {
  return function (p) {
    var tzOffset = new Date().getTimezoneOffset();
    if (p.TimeSinceLastHB - tzOffset <= p.WarningThreshold) {
      return 'SUCCESS';
    } else if (p.TimeSinceLastHB - tzOffset > p.WarningThreshold && p.TimeSinceLastHB - tzOffset <= p.ErrorThreshold) {
      return 'WARNING';
    } else if (p.TimeSinceLastHB - tzOffset > p.ErrorThreshold) {
      return 'ERROR';
    } else {
      return 'UNKNOWN';
    }
  };
};

var listOfservicemonitoring = function listOfservicemonitoring(state) {
  var tzOffset = new Date().getTimezoneOffset();
  return state.servicemonitoring.sort(function (a, b) {
    if (a.ErrorThreshold - (a.TimeSinceLastHB - tzOffset) > b.ErrorThreshold - (b.TimeSinceLastHB - tzOffset)) {
      return 2;
    } else if (a.ErrorThreshold - (a.TimeSinceLastHB - tzOffset) < b.ErrorThreshold - (b.TimeSinceLastHB - tzOffset)) {
      return -2;
    } else if (a.WarningThreshold - (a.TimeSinceLastHB - tzOffset) > b.WarningThreshold - (b.TimeSinceLastHB - tzOffset)) {
      return 1;
    } else if (a.WarningThreshold - (a.TimeSinceLastHB - tzOffset) < b.WarningThreshold - (b.TimeSinceLastHB - tzOffset)) {
      return -1;
    } else {
      return 0;
    }
  });
};

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  TOGGLE_LOADING: function TOGGLE_LOADING(state) {
    state.callingAPI = !state.callingAPI;
  },
  SET_USER: function SET_USER(state, user) {
    state.user = user;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  FETCH_PACKINSTALLEDSAUVEGARDE: function FETCH_PACKINSTALLEDSAUVEGARDE(state, packinstalled) {
    state.packinstalled = packinstalled;
  },
  FETCH_SERVICEMONITORING: function FETCH_SERVICEMONITORING(state, servicemonitoring) {
    state.servicemonitoring = servicemonitoring;
  },
  SET_ADMINSTATUS: function SET_ADMINSTATUS(state, status) {
    state.adminStatus = status;
  },
  SET_USERID: function SET_USERID(state, userId) {
    state.userId = userId;
  },
  SET_USERNAME: function SET_USERNAME(state, userName) {
    state.userName = userName;
  }
});

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  packinstalled: [],
  servicemonitoring: [],
  callingAPI: false,
  serverURI: 'http://intelisoftinformatique:9001',
  user: null,
  token: null,
  userInfo: {}
});

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFound'
});

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_msal__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_msal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_msal__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_msal__["msalMixin"]],
  mounted: function mounted() {
    if (!this.msal.isAuthenticated) {
      this.$router.replace('AuthPage');
    }
  },
  data: function data() {
    return {
      section: 'Head'
    };
  }
});

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_msal__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_msal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_msal__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AuthPage',
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_msal__["msalMixin"]],
  mounted: function mounted() {
    if (this.msal.isAuthenticated) {
      console.log('Authenticated! Forwarding to home page...');
      this.$router.replace('/');
    }
  }
});

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_faker__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_faker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_faker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_DashFooter__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_DashFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__layout_DashFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_DashHeader__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_DashHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__layout_DashHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_Sidebar__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__layout_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hideseek__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hideseek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hideseek__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dash',
  components: {
    DashFooter: __WEBPACK_IMPORTED_MODULE_2__layout_DashFooter___default.a,
    DashHeader: __WEBPACK_IMPORTED_MODULE_3__layout_DashHeader___default.a,
    Sidebar: __WEBPACK_IMPORTED_MODULE_4__layout_Sidebar___default.a
  },
  data: function data() {
    return {
      classes: {
        fixed_layout: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].fixedLayout,
        hide_logo: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].hideLogoOnMobile
      }
    };
  },
  computed: {
    user: function user() {
      return {
        displayName: __WEBPACK_IMPORTED_MODULE_0_faker___default.a.name.findName(),
        avatar: __WEBPACK_IMPORTED_MODULE_0_faker___default.a.image.avatar(),
        roles: [__WEBPACK_IMPORTED_MODULE_0_faker___default.a.name.jobTitle(), __WEBPACK_IMPORTED_MODULE_0_faker___default.a.name.jobTitle()]
      };
    }
  }
});

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashFooter',
  data: function data() {
    return {
      year: new Date().getFullYear()
    };
  }
});

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserMenu__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__UserMenu__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DashHeader',
  components: {
    UserMenu: __WEBPACK_IMPORTED_MODULE_2__UserMenu___default.a
  },
  props: ['user'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])(['userInfo']))
});

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SidebarMenu__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sidebar',
  props: ['user'],
  components: { SidebarMenu: __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default.a },
  mounted: function mounted() {
    window.jQuery('[data-toggle="hideseek"]').off().hideseek();
  }
});

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SidebarMenu'
});

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UserMenu',
  props: ['user']
});

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_Alert__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__widgets_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_InfoBox__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widgets_InfoBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__widgets_InfoBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_ProcessInfoBox__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_ProcessInfoBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__widgets_ProcessInfoBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_msal__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_msal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_msal__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dashboard',
  mixins: [__WEBPACK_IMPORTED_MODULE_6_vue_msal__["msalMixin"]],
  components: {
    Alert: __WEBPACK_IMPORTED_MODULE_2__widgets_Alert___default.a,
    InfoBox: __WEBPACK_IMPORTED_MODULE_3__widgets_InfoBox___default.a,
    ProcessInfoBox: __WEBPACK_IMPORTED_MODULE_4__widgets_ProcessInfoBox___default.a
  },
  data: function data() {
    return {};
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['successpackinstalledCount', 'warningpackinstalledCount', 'errorpackinstalledCount', 'allpackinstalledCount', 'listOfBackupPackInstalled', 'backupAlarmLevel', 'successservicemonitoringCount', 'warningservicemonitoringCount', 'errorservicemonitoringCount', 'allservicemonitoringCount', 'listOfservicemonitoring', 'servicemonitoringAlarmLevel', 'isAdmin'])),
  mounted: function mounted() {
    this.$store.dispatch('fetchpackinstalledSauvegarde');
    this.displayPieChart();
    this.$store.dispatch('fetchservicemonitoring');
    this.displaySMPieChart();
  },

  watch: {
    successpackinstalledCount: function successpackinstalledCount(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.displayPieChart();
      }
    },
    warningpackinstalledCount: function warningpackinstalledCount(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.displayPieChart();
      }
    },
    errorpackinstalledCount: function errorpackinstalledCount(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.displayPieChart();
      }
    },
    allpackinstalledCount: function allpackinstalledCount(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.displayPieChart();
      }
    },
    successservicemonitoringCount: function successservicemonitoringCount(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.displaySMPieChart();
      }
    },
    warningservicemonitoringCount: function warningservicemonitoringCount(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.displaySMPieChart();
      }
    },
    errorservicemonitoringCount: function errorservicemonitoringCount(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.displaySMPieChart();
      }
    },
    allservicemonitoringCount: function allservicemonitoringCount(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.displaySMPieChart();
      }
    }
  },
  methods: {
    displayPieChart: function displayPieChart() {
      var warningPct = Math.round(this.warningpackinstalledCount / this.allpackinstalledCount * 100);
      var successPct = Math.round(this.successpackinstalledCount / this.allpackinstalledCount * 100);
      var errorPct = Math.round(this.errorpackinstalledCount / this.allpackinstalledCount * 100);
      var pieChartCanvas = document.getElementById('backupPie').getContext('2d');
      var pieConfig = {
        type: 'pie',
        data: {
          labels: ['Succès [' + this.successpackinstalledCount + ']', 'Attention [' + this.warningpackinstalledCount + ']', 'Erreur [' + this.errorpackinstalledCount + ']'],
          datasets: [{
            data: [successPct, warningPct, errorPct],
            backgroundColor: ['#28a745', '#ffc107', '#dc3545'],
            hoverBackgroundColor: ['#28a745', '#ffc107', '#dc3545']
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: !this.isMobile,
          legend: {
            position: 'bottom',
            display: true
          }
        }
      };

      new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(pieChartCanvas, pieConfig);
    },
    displaySMPieChart: function displaySMPieChart() {
      var warningPct = Math.round(this.warningservicemonitoringCount / this.allservicemonitoringCount * 100);
      var successPct = Math.round(this.successservicemonitoringCount / this.allservicemonitoringCount * 100);
      var errorPct = Math.round(this.errorservicemonitoringCount / this.allservicemonitoringCount * 100);
      var pieChartCanvas = document.getElementById('servicemonitoringPie').getContext('2d');
      var pieConfig = {
        type: 'pie',
        data: {
          labels: ['Succès [' + this.successservicemonitoringCount + ']', 'Attention [' + this.warningservicemonitoringCount + ']', 'Erreur [' + this.errorservicemonitoringCount + ']'],
          datasets: [{
            data: [successPct, warningPct, errorPct],
            backgroundColor: ['#28a745', '#ffc107', '#dc3545'],
            hoverBackgroundColor: ['#28a745', '#ffc107', '#dc3545']
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: !this.isMobile,
          legend: {
            position: 'bottom',
            display: true
          }
        }
      };

      new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(pieChartCanvas, pieConfig);
    },
    upperCase: function upperCase(value) {
      if (!value) return '';
      value = value.toString();
      return value.toUpperCase();
    }
  }
});

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Alert',
  props: {
    dismissible: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'info'
    },
    iconClasses: {
      type: Array,
      default: []
    },
    title: {
      type: String,
      required: true
    }
  }
});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InfoBox',
  props: {
    text: {
      type: String,
      required: true
    },
    number: {
      type: String,
      default: ''
    },
    iconClasses: {
      type: Array,
      default: []
    },
    colorClass: {
      type: String,
      default: 'bg-default'
    }
  }
});

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InfoBox',
  props: {
    text: {
      type: String,
      required: true
    },
    number: {
      type: String,
      default: ''
    },
    progress: {
      type: Number,
      default: 0,
      validator: function validator(value) {
        return value >= 0 && value <= 100;
      }
    },
    description: {
      type: String,
      default: ''
    },
    iconClasses: {
      type: Array,
      default: []
    },
    colorClass: {
      type: String,
      default: 'bg-default'
    }
  }
});

/***/ }),

/***/ 318:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 319:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 320:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 321:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 322:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 323:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 324:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export app */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return packinstalledService; });
/* unused harmony export packService */
/* unused harmony export containerService */
/* unused harmony export userService */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return servicemonitoringService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__feathersjs_feathers__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__feathersjs_feathers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__feathersjs_feathers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__feathersjs_socketio_client__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__feathersjs_socketio_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__feathersjs_socketio_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_socket_io_client__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_socket_io_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__feathersjs_authentication_client__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__feathersjs_authentication_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__feathersjs_authentication_client__);







var serviceHost;
if (true) {
  serviceHost = 'https://dashboard.intelisoft.ca:9003';
} else {
  serviceHost = 'http://localhost:9003';
}

var socket = __WEBPACK_IMPORTED_MODULE_2_socket_io_client___default()(serviceHost, { transports: ['websocket'], rejectUnauthorized: false });

var app = __WEBPACK_IMPORTED_MODULE_0__feathersjs_feathers___default()();
app.configure(__WEBPACK_IMPORTED_MODULE_1__feathersjs_socketio_client___default()(socket)).configure(__WEBPACK_IMPORTED_MODULE_3__feathersjs_authentication_client___default()({ storage: window.localStorage }));

var packinstalledService = app.service('packinstalled');
var packService = app.service('pack');
var containerService = app.service('container');
var userService = app.service('users');
var servicemonitoringService = app.service('servicemonitoring');

/***/ })

},[227]);


// WEBPACK FOOTER //
// static/js/app.bf337211d4c8fbb959c5.js